
import React from 'react';
import { Progress } from '@/components/ui/progress';

interface ProgressSectionProps {
  progress: number;
}

const ProgressSection: React.FC<ProgressSectionProps> = ({ progress }) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium">Overall Progress</span>
        <span className="text-sm font-medium">{Math.round(progress)}%</span>
      </div>
      <Progress value={progress} className="h-2" />
    </div>
  );
};

export default ProgressSection;
